export default {"src":"https://cdn.wedding-spot.com/_next/static/media/icon.d82219e5.svg","height":163,"width":171};